/* ============
 * Send invoice
 * ============
 *
 * Send invoice email to client.
 */

import Vue from 'vue';

export default id => (
  new Promise((resolve, reject) => {
    Vue.$http.post(`invoices/${id}/send_ehf`)
    .then(() => {
      resolve();
    })
    .catch(() => {
      reject();
    });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/invoice/sendEHF.js